import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { TcsmStates } from '../../root/tcsm-model';
import { useBasePath } from '../hooks/useBasePath';
import { TcsmSiteSettingsProps } from '../models/epi-model';
import { ContentSpacer } from './layout/generic-content-spacer';
import { MainContent } from './layout/main-content-container';
import { PageContainer } from './layout/page-container';
import { PageHeader } from './layout/page-header';
import { WysiwygWithReactLink } from './wysiwyg-with-react-link';

interface Props {
    code?: number;
}
export function ForbiddenErrorMessage(props: Props) {
    const { code } = props;

    const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state.epiProps?.siteSettingsState?.siteSettings);

    const mapHome = useBasePath('');


    const headerText = code === 401
        ? siteSettings?.error401Title || '401 Unauthorized Error'
        : siteSettings?.error403Title || '403 Forbidden Error';

    const messageText = code === 401
        ? siteSettings?.error401Message || '401 unauthorized'
        : siteSettings?.error403Message || '403 Forbidden';

    return (
        <PageContainer>
            <MainContent>
                <PageHeader headerText={headerText} />
                <ContentSpacer>
                    <WysiwygWithReactLink content={messageText} />
                </ContentSpacer>
                <ContentSpacer>
                    <Link to={mapHome}>{siteSettings?.error401403HomeLinkText || 'Go to Home Page'}</Link>
                </ContentSpacer>
            </MainContent>
        </PageContainer>
    );
}

ForbiddenErrorMessage.defaultProps = {
    code: 403,
};